@if (userDeviceInfo === 'pc') {
  <div
    (click)="onAddToCart()"
    class="select-all {{ userDeviceInfo }}"
    [class.disable]="productService.selectProducts.length === 0"
  >
    <div>{{ productService.selectProducts.length }} items Add to cart</div>
  </div>
}
